<footer class="footer__container">
  <div class="footer__wrapper">
    <p class="text-xs text-gray-1 lh-24 my-0">
      Copyright© 2021 BLACK iD. Todos los derechos reservados.
    </p>
  </div>
</footer>
